customElements.get("product-form")||customElements.define("product-form",class extends HTMLElement{constructor(){super(),this.form=this.querySelector("form"),this.form&&(this.form.querySelector("[name=id]").disabled=!1,this.form.addEventListener("submit",this.onSubmitHandler.bind(this))),this.cart=document.querySelector("cart-notification")||document.querySelector("cart-drawer"),this.submitButton=this.querySelector('[type="submit"]'),document.querySelector("cart-drawer")&&this.submitButton.setAttribute("aria-haspopup","dialog"),this.hideErrors="true"===this.dataset.hideErrors}onSubmitHandler(e){e.preventDefault();const t=this.querySelector('[type="submit"]');if(t.classList.contains("loading"))return;const r=document.querySelectorAll(".product__line_item_property")||[];let s=[];for(let e=0;e<r.length;e++){const t=r[e],o=t.getAttribute("data-type");let i="radio"==o?t.querySelector(".form__groups-radio"):"checkbox"==o?t.querySelector(".form__groups-checkbox"):t.querySelector(".form__group");if("radio"==o){const e=t.querySelector("input"),r=t.querySelector("input:checked"),o=r?r.value:null,a=!(!e.hasAttribute("required")||o);s=[...s,{name:e.name,value:o,error:a}],a?(e.focus(),e.reportValidity(),i&&i.classList.add("error")):i&&i.classList.remove("error")}else{const e=t.querySelector("input, textarea, select");let r=!1;r="checkbox"==o?!(!e.hasAttribute("required")||e.checked):!(!e.hasAttribute("required")||e.value.trim()),s=[...s,{name:e.name,value:e.value.trim(),error:r}],r?(e.focus(),e.reportValidity(),i&&i.classList.add("error")):i&&i.classList.remove("error")}}const o=s.every(e=>!e.error);if(s.length>0&&!o)return;this.handleErrorMessage(),t.setAttribute("aria-disabled",!0),t.classList.add("loading");const i=fetchConfig("javascript");i.headers["X-Requested-With"]="XMLHttpRequest",delete i.headers["Content-Type"];const a=new FormData(this.form);if(this.cart){a.append("sections",this.cart.getSectionsToRender().map(e=>e.id)),a.append("sections_url",window.location.pathname);for(let e=0;e<s.length;e++){const t=s[e];a.append(t.name,t.value)}this.cart.setActiveElement(document.activeElement)}i.body=a,fetch(`${routes.cart_add_url}`,i).then(e=>e.json()).then(e=>{if(e.status){publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:a.get("id"),errors:e.errors||e.description,message:e.message}),this.handleErrorMessage(e.description),this.error=!0;const t=this.submitButton.querySelector(".sold-out-message");if(!t)return;return this.submitButton.setAttribute("aria-disabled",!0),this.submitButton.querySelector("span").classList.add("hidden"),void t.classList.remove("hidden")}if(!this.cart)return void(window.location=window.routes.cart_url);null!=document.querySelector(".quick-options-drawer.open")&&(document.querySelector(".quick-options-drawer.open").classList.remove("open"),document.querySelector("body").classList.remove("quick-options-open")),this.error||publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:a.get("id"),cartData:e}),this.error=!1;const t=document.getElementById("product-quick-add-dialog");t?(t.hide(),this.cart.renderContents(e)):this.cart.renderContents(e)}).catch(e=>{console.error(e)}).finally(()=>{this.submitButton.classList.remove("loading"),!this.error&&this.cart&&this.cart.classList.contains("is-empty")&&this.cart.classList.remove("is-empty"),this.error||this.submitButton.removeAttribute("aria-disabled")})}handleErrorMessage(e=!1){this.errorMessageWrapper=this.errorMessageWrapper||this.querySelector(".product-form__error-message-wrapper"),this.errorMessage=this.errorMessage||this.errorMessageWrapper.querySelector(".product-form__error-message"),e?(this.errorMessageWrapper.classList.add("flex"),this.errorMessageWrapper.classList.remove("hidden")):(this.errorMessageWrapper.classList.add("hidden"),this.errorMessageWrapper.classList.remove("flex")),e&&(this.errorMessage.textContent=e)}});


// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       if (this.form) {
//         this.form.querySelector('[name=id]').disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       }
      
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       this.submitButton = this.querySelector('[type="submit"]');
      
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//       this.hideErrors = this.dataset.hideErrors === 'true';
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       const submitButton = this.querySelector('[type="submit"]');
//       if (submitButton.classList.contains('loading')) return;
      
//       const properties = document.querySelectorAll('.product__line_item_property') || [];
//       let additionalData = [];
//       for (let index = 0; index < properties.length; index++) {
//         const property = properties[index];
//         const type = property.getAttribute('data-type');
//         let formGroup = type == 'radio' ? property.querySelector('.form__groups-radio') : type == 'checkbox' ? property.querySelector('.form__groups-checkbox') : property.querySelector('.form__group');
        
//         if (type == 'radio') {
//           const input = property.querySelector('input');
//           const selectedRadio = property.querySelector('input:checked');
//           const radioValue = selectedRadio ? selectedRadio.value : null;
//           const error = input.hasAttribute('required') && !radioValue ? true : false;
//           additionalData = [...additionalData, {
//             name: input.name,
//             value: radioValue,
//             error: error
//           }];
          
//           if (error) {
//             input.focus();
//             input.reportValidity();
//             if (formGroup) formGroup.classList.add('error');
//           } else {
//             if (formGroup) formGroup.classList.remove('error');
//           }
//         } else {
//           const input = property.querySelector('input, textarea, select');
//           let error = false;
//           if (type == 'checkbox') {
//             error = input.hasAttribute('required') && !input.checked ? true : false;
//           } else {
//             error = input.hasAttribute('required') && !input.value.trim() ? true : false;
//           }
//           additionalData = [...additionalData, {
//             name: input.name,
//             value: input.value.trim(),
//             error: error
//           }];
//           if (error) {
//             input.focus();
//             input.reportValidity();
//             if (formGroup) formGroup.classList.add('error');
//           } else {
//             if (formGroup) formGroup.classList.remove('error');
//           }
//         }
//       }

//       const validAdditionalData = additionalData.every(d => !d.error);
//       if (additionalData.length > 0 && !validAdditionalData) return;
      
//       this.handleErrorMessage();

//       submitButton.setAttribute('aria-disabled', true);
//       submitButton.classList.add('loading');
//       // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];
      
//       const formData = new FormData(this.form);
//       if (this.cart) {
//         formData.append(
//           'sections',
//           this.cart.getSectionsToRender().map((section) => section.id)
//         );
//         formData.append('sections_url', window.location.pathname);
//         for (let index = 0; index < additionalData.length; index++) {
//           const data = additionalData[index];
//           formData.append(data.name, data.value);
//         }
//         this.cart.setActiveElement(document.activeElement);
//       }
//       config.body = formData;
      
//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             publish(PUB_SUB_EVENTS.cartError, {
//               source: 'product-form',
//               productVariantId: formData.get('id'),
//               errors: response.errors || response.description,
//               message: response.message,
//             });
//             this.handleErrorMessage(response.description);
//             this.error = true;
//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             return;
//           } else if (!this.cart) {
//             window.location = window.routes.cart_url;
//             return;
//           }
//           if ( document.querySelector('.quick-options-drawer.open') != null ) {
//             document.querySelector('.quick-options-drawer.open').classList.remove('open');
//             document.querySelector('body').classList.remove('quick-options-open');
//           }


//           if (!this.error)
//             publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
//           this.error = false;
//           const quickAddModal = document.getElementById('product-quick-add-dialog');
//           if (quickAddModal) {
//             quickAddModal.hide();
//             this.cart.renderContents(response);
//           } else {
//             this.cart.renderContents(response);
//           }

//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (!this.error && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
//       if (errorMessage) {
//         this.errorMessageWrapper.classList.add('flex');
//         this.errorMessageWrapper.classList.remove('hidden');
//       } else {
//         this.errorMessageWrapper.classList.add('hidden');
//         this.errorMessageWrapper.classList.remove('flex');
//       }

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }
